







import { Component, Vue, Prop } from 'vue-property-decorator'
import { CellClassParams } from '@ag-grid-community/all-modules'

interface KintaiOptonStringCellClassParams extends CellClassParams {
  type: 'plain' | 'info' | 'danger'
  optionString?: string
}

@Component
export default class GridCellDecorationString extends Vue {
  @Prop({ default: '' })
  private value!: string
  @Prop({ default: 'plain' })
  private type!: 'plain' | 'info' | 'danger'
  @Prop({ default: '' })
  private optionString!: string

  get tagType(): string {
    return `optional-tag-${this.type}`
  }
}
